import type { ResultsState } from './results';

export const getRoleIdFromResults = (results: ResultsState) => {
  const roleIds = results?.results?.jobs
    ?.map((job) => !job.isPremium && job.roleId)
    .filter((id) => id);

  return roleIds?.[0] || undefined;
};
